<template>
  <el-form ref="ff" v-loading="loading" :model="formdata" label-position="top">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="客户单位" prop="Customer" required>
          <customerPicker :value="formdata.CustomerName" clearable @change="pickCustomer" style="width: 100%" />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="联系人" prop="Linkman">
          <el-input v-model="formdata.Linkman" clearable />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="电话" prop="Linktel">
          <el-input v-model="formdata.Linktel" />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="商务平台" prop="Platform" required>
          <metaPicker type="platform" :value.sync="formdata.Platform" />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="结算方式" prop="POClear">
          <metaPicker type="POClear" :value.sync="formdata.POClear" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="经销商打款账户" prop="Bankcard">
          <el-input v-model="formdata.Bankcard" />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="平台点率" required prop="PlatformRate">
          <el-input v-model="formdata.PlatformRate">
            <template slot="suffix">%</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="公司点率" required prop="CompanyRate">
          <el-input v-model="formdata.CompanyRate">
            <template slot="suffix">%</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="供应商/平台结算金额" required prop="TotalAmount">
          <el-input v-model="formdata.TotalAmount">
            <template slot="prefix">￥</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="与经销商结算金额" required prop="FinalAmount">
          <el-input v-model="formdata.FinalAmount">
            <template slot="prefix">￥</template>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item prop="Remark" label="订单备注">
      <el-input type="textarea" :rows="5" v-model="formdata.Remark" />
    </el-form-item>
    <el-form-item>
      <uploader ref="uploadRef1" :data="{ ObjectId: $route.params.id, Mode: 'customer-document' }" multiple :auto-upload="false" accept=".jpg,.png,.xls,.xlsx,.pdf,.doc,.docx,.rar,.zip">
        <el-link slot="trigger" icon="el-icon-upload" size="small" type="primary">与经销商确认文件</el-link>
      </uploader>
      <uploader ref="uploadRef2" :data="{ ObjectId: $route.params.id, Mode: 'customer-contract' }" multiple :auto-upload="false" accept=".jpg,.png,.xls,.xlsx,.pdf,.doc,.docx,.rar,.zip">
        <el-link slot="trigger" icon="el-icon-upload" size="small" type="primary">与经销商合同</el-link>
      </uploader>
      <uploader ref="uploadRef3" :data="{ ObjectId: $route.params.id, Mode: 'customer-invoice' }" multiple :auto-upload="false" accept=".jpg,.png,.xls,.xlsx,.pdf,.doc,.docx,.rar,.zip">
        <el-link slot="trigger" icon="el-icon-upload" size="small" type="primary">与经销商发票</el-link>
      </uploader>
      <uploader ref="uploadRef4" :data="{ ObjectId: $route.params.id, Mode: 'purchaser-contract' }" multiple :auto-upload="false" accept=".jpg,.png,.xls,.xlsx,.pdf,.doc,.docx,.rar,.zip">
        <el-link slot="trigger" icon="el-icon-upload" size="small" type="primary">与采购人合同</el-link>
      </uploader>
      <uploader ref="uploadRef5" :data="{ ObjectId: $route.params.id, Mode: 'purchaser-invoice' }" multiple :auto-upload="false" accept=".jpg,.png,.xls,.xlsx,.pdf,.doc,.docx,.rar,.zip">
        <el-link slot="trigger" icon="el-icon-upload" size="small" type="primary">与采购人发票</el-link>
      </uploader>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="onSubmit()">提交订单</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  components: {
    customerPicker: () => import('@/views/company/customer/_picker.vue'),
    metaPicker: () => import("@/views/system/meta/item/_picker.vue"),
    uploader: () => import("@/views/system/file/multipleUpload.vue"),
  },
  data () {
    return {
      loading: false,
      formdata: {}
    }
  },
  created () {
    let id = this.$route.params?.id
    if (id) {
      this.$apis.mall.torder.info({
        id: id
      }).then(res => {
        if (res != null) {
          this.formdata = res
        }
        else {
          this.$router.go(-1)
        }
      })
    }
  },
  computed: {
    amountChange () {
      let TotalAmount = this.formdata.TotalAmount
      let PlatformRate = this.formdata.PlatformRate
      let CompanyRate = this.formdata.CompanyRate
      return {
        TotalAmount,
        PlatformRate,
        CompanyRate
      }
    }
  },
  watch: {
    amountChange: {
      handler: function (val) {
        var value = ((val.TotalAmount || 0) * (100 - (val.PlatformRate || 0) - (val.CompanyRate || 0)) / 100).toFixed(2)
        this.$set(this.formdata, "FinalAmount", value)
      }
    }
  },
  methods: {
    //选择客户
    pickCustomer (res) {
      this.$set(this.formdata, "Customer", res.Id)
      this.$set(this.formdata, 'CustomerName', res.Name)
      this.$set(this.formdata, "Linkman", res.Linkman)
      this.$set(this.formdata, "Linktel", res.Linktel)
      this.$set(this.formdata, "Bankcard", res.Card)
    },
    //提交订单
    onSubmit () {
      this.$refs['ff'].validate(valid => {
        if (valid && !this.loading) {
          this.loading = true
          this.$apis.mall.torder.submit(this.formdata).then(res => {
            this.$set(this.formdata, "Id", res)
            return this.$refs.uploadRef1.onSubmit(this.formdata.Id)
          }).then(() => {
            return this.$refs.uploadRef2.onSubmit(this.formdata.Id)
          }).then(() => {
            return this.$refs.uploadRef3.onSubmit(this.formdata.Id)
          }).then(() => {
            return this.$refs.uploadRef4.onSubmit(this.formdata.Id)
          }).then(() => {
            return this.$refs.uploadRef5.onSubmit(this.formdata.Id)
          }).then(() => {
            this.$message({ message: "数据提交成功！", type: "success" })
            this.$router.replace({ path: `/mall/torder/list` })
          }).catch(e => {
            this.$message.error(e || "执行错误")
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form {
  background: #fff;
  min-width: 640px;
  width: 72%;
  padding: 20px;
}
</style>
